import { createSlice } from '@reduxjs/toolkit'
import {
  IConfigDetails,
  IInsertRowPayloadType,
  IInsertRowsPayloadType,
  IPopulateConfigDetailsPayloadType,
  IPupulateTableIdLookupPayloadType,
  IRuleConfigState,
  ISetRulesPayloadType,
  IUpdateCellPayloadType,
  IUpdateRuleMetaPayloadType,
} from '../types/ruleConfig.types'

const initialState: IRuleConfigState = {
  ruleLoadingState: [],
  ruleConfig: {},
  configDetails: {
    selected_product: '',
    selected_program: '',
    selected_criteria: '',
    selected_service: '',
    selected_sub_service: '',
  },
}

const ruleConfigSlice = createSlice({
  name: 'ruleConfig',
  initialState,
  reducers: {
    setRules: (state, action: ISetRulesPayloadType) => {
      const { rules } = action.payload
      rules?.forEach((rule) => {
        if (!state?.ruleConfig?.[rule.name]) {
          state.ruleConfig[rule.name] = {
            rows: {},
            row_order: [],
            rule_meta: {
              record_status: rule.record_status,
              name: rule.name,
              rule_id: rule.id,
              rule_label: rule.label,
            },
          }
        }
      })
    },
    resetRules: (state) => {
      state.ruleConfig = {}
    },
    insertRows: (state, action: IInsertRowsPayloadType) => {
      const { rule_id, rows } = action.payload
      if (!state?.ruleConfig?.[rule_id]) {
        state.ruleConfig[rule_id] = {
          rows: {},
          row_order: [],
          rule_meta: {
            record_status: null,
            name: '',
          },
        }
      }
      rows.forEach((row) => {
        const row_id = row.id
        state.ruleConfig[rule_id].rows[row_id] = row
        state.ruleConfig[rule_id].row_order.push(row_id)
      })
    },
    updateCell: (state, action: IUpdateCellPayloadType) => {
      const { rule_id, row_id, column_id, content } = action.payload
      if (state?.ruleConfig?.[rule_id]) {
        const row = state.ruleConfig[rule_id].rows[row_id]
        if (row) {
          row[column_id] = content
        }
      }
    },
    updateRuleMeta: (state, action: IUpdateRuleMetaPayloadType) => {
      const { rule_id, record_status } = action.payload
      if (state?.ruleConfig?.[rule_id]) {
        state.ruleConfig[rule_id].rule_meta.record_status = record_status
      }
    },
    populateTableIdLookup: (
      state,
      action: IPupulateTableIdLookupPayloadType
    ) => {
      state.ruleConfig[action.payload.rule_id].table_id_lookup =
        action.payload.data
    },
    resetRuleConfig: (state) => {
      state.ruleConfig = {}
      state.configDetails = {
        selected_criteria: '',
        selected_product: '',
        selected_program: '',
        selected_service: '',
        selected_sub_service: '',
      }
    },
    insertRow: (state, action: IInsertRowPayloadType) => {
      const { rule_id, row } = action.payload
      if (!state?.ruleConfig?.[rule_id]) {
        state.ruleConfig[rule_id] = {
          rows: {},
          row_order: [],
          rule_meta: {
            record_status: null,
            name: '',
          },
        }
      }
      state.ruleConfig[rule_id].rows[row.id] = row
      state.ruleConfig[rule_id].row_order.push(row.id)
    },
    updateRow: (state, action: IInsertRowPayloadType) => {
      const { rule_id, row } = action.payload
      if (!state?.ruleConfig?.[rule_id]) {
        state.ruleConfig[rule_id] = {
          rows: {},
          row_order: [],
          rule_meta: {
            record_status: null,
            name: '',
          },
        }
      }
      state.ruleConfig[rule_id].rows = {}
      state.ruleConfig[rule_id].rows[row.id] = row
      state.ruleConfig[rule_id].row_order = [row.id]
    },
    populateConfigDetails: (
      state,
      action: IPopulateConfigDetailsPayloadType
    ) => {
      state.configDetails[action.payload.name as keyof IConfigDetails] =
        action.payload.value
    },
    handleRuleConfigLoading: (state, action: { payload: string }) => {
      if (state?.ruleLoadingState?.includes(action.payload)) {
        state.ruleLoadingState = state.ruleLoadingState.filter(
          (item) => item !== action.payload
        )
      } else {
        state.ruleLoadingState.push(action.payload)
      }
    },
  },
})

export const {
  setRules,
  insertRows,
  updateCell,
  updateRuleMeta,
  resetRuleConfig,
  populateTableIdLookup,
  populateConfigDetails,
  insertRow,
  updateRow,
  resetRules,
  handleRuleConfigLoading,
} = ruleConfigSlice.actions
export default ruleConfigSlice.reducer
